import * as React from 'react';
import NewVendorReportTabPanel from './NewVendorReportTabPanel';
import { RouteComponentProps } from 'react-router';
export class NewVendorReport extends React.Component<RouteComponentProps<{}>, { }> {
    public render() {
        console.log(this.props)
        return <div className="new-vendor-report">
            <NewVendorReportTabPanel {...this.props} />
        </div>;
    }
}